import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import ArticleDetail from '@/views/ArticleDetail.vue'
import CategoryList from '@/views/CategoryList.vue'
import TagList from '@/views/TagList.vue'

import AdminLogin from '@/views/admin/Login.vue'
import AdminDingTalkCallback from '@/views/admin/DingTalkCallback.vue'
import Admin from '@/views/admin/Admin.vue'
import AdminArticleList from '@/views/admin/ArticleList.vue'
import AdminCategoryList from '@/views/admin/CategoryList.vue'
import AdminTagList from '@/views/admin/TagList.vue'
import AdminCommentList from '@/views/admin/CommentList.vue'
import AdminUserList from '@/views/admin/UserList.vue'
import AdminConfig from '@/views/admin/ConfigPage.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/article/:id',
      name: 'ArticleDetail',
      component: ArticleDetail
    },
    {
      path: '/categories',
      name: 'CategoryList',
      component: CategoryList
    },
    {
      path: '/tags',
      name: 'TagList',
      component: TagList
    },
    {
      path: '/admin/login',
      name: 'AdminLogin',
      component: AdminLogin
    },
    {
      path: '/admin/login/callback',
      name: 'AdminDingTalkCallback',
      component: AdminDingTalkCallback
    },
    {
      path: '/admin',
      component: Admin,
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          name: 'AdminArticleList',
          component: AdminArticleList
        },
        {
          path: 'articles',
          component: AdminArticleList
        },
        {
          path: 'categories',
          name: 'AdminCategoryList',
          component: AdminCategoryList
        },
        {
          path: 'tags',
          name: 'AdminTagList',
          component: AdminTagList
        },
        {
          path: 'comments',
          name: 'AdminCommentList',
          component: AdminCommentList
        },
        {
          path: 'users',
          name: 'AdminUserList',
          component: AdminUserList
        },
        {
          path: 'config',
          name: 'AdminConfig',
          component: AdminConfig
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const loggedIn = sessionStorage.getItem('admin_logged')
    if (!loggedIn) {
      next('/admin/login')
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
